import React from "react";
import {
  bemClassesFromModifiers,
  dateFromTimestamp,
} from "../../constants/misc";
import "./messageBox.css";
import PngIcon from "../svgs/pngIcon";
import JpgIcon from "../svgs/jpgIcon";
import { BASE_URL } from "../../config";

const MessageBox = (props) => {
  const { title, isAnswer, created, body, attachmentsUrl } = props;

  // Handle new attachment object format or legacy URL string
  const handleDownload = (event, attachment) => {
    event.preventDefault();

    if (attachment && typeof attachment === "object") {
      // New format: attachment object with url and fileName
      const url = attachment.url;
      const fileName = attachment.fileName || "download";

      if (url && url.startsWith("data:")) {
        // Base64 data URL - download directly
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        // Regular URL - open in new tab
        window.open(BASE_URL + url, "_blank");
      }
    } else if (typeof attachmentsUrl === "string") {
      // Legacy format: URL string
      window.open(BASE_URL + attachmentsUrl, "_blank");
    }
  };

  // Support both new object format and legacy URL string format
  let attachments = [];

  if (attachmentsUrl && typeof attachmentsUrl === "object") {
    // New format: single attachment object
    const fileName = attachmentsUrl.fileName || "attachment";
    const png = fileName.toLowerCase().indexOf("png") > -1;

    attachments = [
      <span key={fileName} className="comment_txt__attachment">
        <a href="#" onClick={(e) => handleDownload(e, attachmentsUrl)}>
          {png ? (
            <PngIcon className="file-icon" />
          ) : (
            <JpgIcon className="file-icon" />
          )}
          <span style={{ verticalAlign: "super" }}>{fileName}</span>
        </a>
      </span>,
    ];
  } else if (attachmentsUrl && typeof attachmentsUrl === "string") {
    // Legacy format: comma-separated URLs
    const urls = attachmentsUrl.split(",").map((url) => url.trim());

    attachments = urls.map((url) => {
      const fileName = url.substring(url.lastIndexOf("/") + 1, url.length);
      const png = url.indexOf("png") > -1;
      return (
        <span key={fileName} className="comment_txt__attachment">
          <a href={BASE_URL + url} target="_blank" rel="noopener noreferrer">
            {png ? (
              <PngIcon className="file-icon" />
            ) : (
              <JpgIcon className="file-icon" />
            )}
            <span style={{ verticalAlign: "super" }}>{fileName}</span>
          </a>
        </span>
      );
    });
  }

  return (
    <div
      style={{ marginTop: "1rem" }}
      className={bemClassesFromModifiers("message", [
        isAnswer ? "answer" : null,
      ])}
    >
      <div className="support title_table">
        <div className="post_title title_cell">
          <div className="support_comment_user">{title}</div>
          <div className="support_comment_date">
            {dateFromTimestamp(created).toDateString()}
          </div>
        </div>
        <div className="title_right_side title_cell" />
      </div>

      <div className="comment_txt">
        <div dangerouslySetInnerHTML={{ __html: body }} />
        {attachmentsUrl && (
          <span style={{ marginTop: 25, display: "inline-block" }}>
            Attachment(s) :
          </span>
        )}
        {attachments}
      </div>
    </div>
  );
};

export default MessageBox;
